import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { manhattanConfig } from "./data";

export default function ManhattanPage() {
  return <CityPageTemplate config={manhattanConfig} />;
}